import { render, staticRenderFns } from "./CMAddContactGroupContactList.vue?vue&type=template&id=3f90f9b0&"
import script from "./CMAddContactGroupContactList.vue?vue&type=script&lang=js&"
export * from "./CMAddContactGroupContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f90f9b0')) {
      api.createRecord('3f90f9b0', component.options)
    } else {
      api.reload('3f90f9b0', component.options)
    }
    module.hot.accept("./CMAddContactGroupContactList.vue?vue&type=template&id=3f90f9b0&", function () {
      api.rerender('3f90f9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMAddContactGroupContactList.vue"
export default component.exports